





































import { Component, Prop, Vue } from 'vue-property-decorator';
import AppHeader from '@components/header/app-header.vue';
import { Component as ComponentType } from 'vue';
import FooterBasic from '@components/footer/footer-basic.vue';
import FooterFull from '@components/footer/footer-full.vue';

@Component({
	components: {
		AppHeader,
		FooterBasic,
		FooterFull
	}
})
export default class AppLayout extends Vue {
	@Prop({ default: false })
	footerFull!: boolean;

	@Prop({ default: false })
	transparentHeader!: boolean;

	@Prop({ default: false })
	transparentHeaderDarkText!: boolean;

	@Prop({ default: false })
	verticallyCentered!: boolean;

	@Prop({ default: true })
	includePadding!: boolean;

	@Prop({ default: 'bg-color-slate-97' })
	backgroundColorClass!: string;

	@Prop({ default: false })
	contentFullHeight!: boolean;

	@Prop({ default: null })
	footnotes!: Array<string>;

	get footerComponent(): ComponentType {
		return this.footerFull ? FooterFull : FooterBasic;
	}
}
